<template>
  <div id="personal-information">
    <v-card id="v-card" v-if="StartupLoadingFlag">
      <v-container>
        <v-row wrap>
          <v-col cols="12" xl="4" md="6" sm="6" v-for="n in 4" :key="n">
            <br />
            <br />
            <v-skeleton-loader
              v-bind="attrs"
              type="paragraph"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card
      elevation="4"
      outlined
      shaped
      v-if="!StartupLoadingFlag"
      id="v-card"
    >
      <v-card-text id="card-text">
        <v-row wrap>
          <v-col cols="12" sm="12" md="12" lg="3">
            <h3 class="text-dark">
              <i id="app-bar-icon" class="fas fa-user"></i>&nbsp;&nbsp;
              <b id="heading">Personal Information</b>
            </h3>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="9" class="text-center">
            <p v-if="rows.MemberActivityListFlag">
              <v-icon dark> mdi-crown </v-icon> {{ rows.TrainerPoints }} Points
            </p>
            <v-btn
              v-if="rows.ProfileUpdated == 0"
              class="mx-1 mt-2"
              color="red"
              small
              @click.prevent="openUpdateProfile"
            >
              <v-icon dark color="white" small>
                fas fa-exclamation-circle
              </v-icon>
              <span style="color: white; font-size: 10px">
                &nbsp; Update Profile</span
              >
            </v-btn>
            <v-btn
              v-if="!rows.MemberQrCodeFlag"
              class="mx-1 mt-2"
              color="#EC407A"
              small
              @click.prevent="generateQrCodeDetails"
            >
              <v-icon dark color="white" small> fa-solid fa-qrcode </v-icon>
              <span style="color: white; font-size: 10px">
                &nbsp; Generate Qr-Code
              </span>
            </v-btn>
            <router-link
              to="/my-activity/list"
              v-if="rows.MemberActivityListFlag"
            >
              <v-btn class="mx-1 mt-2" color="green" small>
                <v-icon dark color="white" small>
                  fa-solid fa-user-clock
                </v-icon>
                <span style="color: white; font-size: 10px"
                  >&nbsp; Trainer Activities</span
                >
              </v-btn>
            </router-link>
            <router-link
              to="/nominate-member/nomination-apply/list"
              v-if="rows.NominationApplyFlag"
            >
              <v-badge
                color="red"
                content="NEW"
                overlap
                offset-x="10"
                offset-y="10"
              >
                <v-btn
                  class="text-uppercase mx-1 mt-2 text-white"
                  color="#2e8b57"
                  small
                  style="font-weight: bold"
                >
                  Apply for Zone/National Election
                </v-btn>
              </v-badge>
            </router-link>
            <!-- <p
              class="btn btn-sm text-uppercase"
              id="edit-button"
              @click.prevent="openRecordPrompt"
            >
              Edit
            </p>
            <p
              class="btn btn-sm text-uppercase"
              id="edit-button"
              @click.prevent="openRecordPrompt1"
            >
              Change Password
            </p> -->
          </v-col>
        </v-row>

        <v-row dense>
          <!-- LEFT: Profile Image + Buttons -->
          <v-col cols="12" sm="12" md="4" lg="3" xl="3" class="text-center">
            <v-img
              :src="rows.MemberImagePath"
              :alt="rows.MemberName"
              lazy-src="/no-image-available.png"
              max-width="250"
              class="mx-auto"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <div
              class="d-flex justify-center mt-2"
              style="gap: 5px; flex-wrap: wrap"
            >
              <v-btn small color="green" dark @click.prevent="addRecord">
                <v-icon left small>mdi-upload</v-icon> Upload Photo
              </v-btn>
              <v-btn
                small
                color="warning"
                dark
                @click.prevent="openRecordPrompt"
              >
                Edit
              </v-btn>
              <v-btn
                small
                color="#3A67B1"
                dark
                @click.prevent="openRecordPrompt1"
              >
                Change Password
              </v-btn>
            </div>
          </v-col>

          <!-- CENTER: Member Details + Progress -->
          <v-col cols="12" sm="12" md="5" lg="6" xl="6">
            <div class="d-flex align-center justify-space-between flex-wrap">
              <div>
                <h4 class="mb-1">
                  {{ rows.MemberName }}
                  <i v-bind:class="rows.AadharStatusIcon" class="ml-1"></i>
                </h4>
                <p class="mb-1">
                  <i class="flaticon2-calendar-3 mr-1"></i>{{ rows.MobileNo }}
                  <i v-bind:class="rows.MobileNoIcon" class="ml-1"></i>
                </p>
                <p>
                  <i class="flaticon2-new-email mr-1"></i>{{ rows.EmailId }}
                  <i v-bind:class="rows.EmailIdIcon" class="ml-1"></i>
                </p>
              </div>
            </div>

            <v-row wrap>
              <v-col cols="6" md="9">
                <v-row wrap>
                  <!-- Membership ID -->
                  <v-col cols="6" md="4">
                    <h6 class="text-dark-50">Membership Id</h6>
                    <h6>{{ rows.MembershipId }}</h6>
                  </v-col>

                  <!-- DOB -->
                  <v-col cols="6" md="4">
                    <h6 class="text-dark-50">Date Of Birth</h6>
                    <h6>{{ rows.DOB }}</h6>
                  </v-col>

                  <!-- Gender -->
                  <v-col cols="6" md="4">
                    <h6 class="text-dark-50">Gender</h6>
                    <h6>{{ rows.GenderTxt }}</h6>
                  </v-col>
                  <!-- Marital Status -->
                  <v-col cols="6" md="4">
                    <h6 class="text-dark-50">Marital Status</h6>
                    <h6>{{ rows.MartialStatusTxt }}</h6>
                  </v-col>

                  <!-- Anniversary Date -->
                  <v-col cols="6" md="4" v-if="rows.MartialStatus == 1">
                    <h6 class="text-dark-50">Anniversary Date</h6>
                    <h6>{{ rows.AnniversaryDate }}</h6>
                  </v-col>

                  <!-- Blood Group -->
                  <v-col cols="6" md="4">
                    <h6 class="text-dark-50">Blood Group</h6>
                    <h6>{{ rows.BloodGroupTxt }}</h6>
                  </v-col>
                  <v-col cols="12">
                    <h6 class="text-dark-50">About Me</h6>
                    <h6>{{ rows.AboutMe }}</h6>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Progress Circular moved here -->
              <v-col
                cols="6"
                md="3"
                class="pa-0 d-flex flex-column align-center justify-center"
              >
                <h3
                  class="text-subtitle-1 font-weight-medium mb-1"
                  style="color: #555"
                  v-if="rows.ProfileStatusPercentage < 100"
                >
                  <span
                    style="color: #d32f2f"
                  >
                    {{ rows.ProfileMissingSteps }}
                  </span>
                </h3>

                <template v-if="rows.ProfileStatusPercentage < 100">
                  <v-progress-circular
                    :value="Number(rows.ProfileStatusPercentage)"
                    :rotate="-90"
                    :size="80"
                    :width="10"
                    :color="rows.ProfileStatusColor"
                    background-color="#d9d9d9"
                    class="mb-1"
                  >
                    <div style="font-weight: bold; color: black">
                      {{ rows.ProfileStatusPercentage }}%
                    </div>
                  </v-progress-circular>

                  <div style="font-weight: bold; color: black">
                    {{ rows.ProfileStatusCount }}/{{ rows.ProfileStatusTotal }}
                  </div>
                </template>

                <v-chip
                  :color="rows.ProfileStatusColor"
                  text-color="white"
                  class="ma-1 px-4 py-2"
                  pill
                >
                  {{ rows.ProfileStatusTxt }}
                </v-chip>
              </v-col>
            </v-row>
          </v-col>

          <!-- RIGHT: QR Image + Buttons -->
          <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="text-center">
            <v-img
              v-if="rows.MemberQrCodeFlag"
              :src="rows.MemberQrImagePath"
              :alt="rows.MemberName"
              lazy-src="/no-image-available.png"
              max-width="250"
              class="mx-auto"
            ></v-img>

            <div
              class="d-flex justify-center mt-2"
              style="gap: 5px; flex-wrap: wrap"
            >
              <v-btn
                v-if="rows.IdCardFlag != ''"
                :href="rows.IdCardPath"
                target="_blank"
                small
                color="#56BDA3"
                dark
              >
                Member Id Card
              </v-btn>
              <v-btn
                v-if="rows.MemberCertificateFlag != ''"
                :href="rows.MemberCertificatePath"
                target="_blank"
                small
                color="#0097D7"
                dark
              >
                Member Certificate
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addRecordPrompt2" persistent max-width="80%">
      <upload-profile-picture
        pageTitle="Change Profile Picture"
        pageDescription=""
        :addRecordPrompt="addRecordPrompt2"
        :currentPhoto="current_photo"
        @hideAddRecordPrompt="changeProfilePhoto"
        v-if="addRecordPrompt2"
      ></upload-profile-picture>
    </v-dialog>

    <v-dialog v-model="addRecordPrompt" persistent max-width="80%">
      <KTPersonalInformation
        v-if="UserFlag && addRecordPrompt"
        :member="rows"
        @hideAddRecordPrompt="hideAddRecordPrompt"
      ></KTPersonalInformation>
    </v-dialog>

    <v-dialog v-model="addRecordPrompt1" persistent max-width="80%">
      <KTChangePassword
        v-if="UserFlag && addRecordPrompt1"
        :member="rows"
        @hideAddRecordPrompt="hideAddRecordPrompt1"
      ></KTChangePassword>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { UPDATE_PERSONAL_INFO } from "@/core/services/store/profile.module";
import companyConfig from "@/company_config.json";
import common from "@/view/Common.vue";

import UploadProfilePicture from "@/view/pages/profile/my-profile/UploadProfilePicture2.vue";
import KTPersonalInformation from "@/view/pages/profile/my-profile/PersonalInformation";
import KTChangePassword from "@/view/pages/profile/my-profile/ChangePassword";

import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";

export default {
  mixins: [common],
  components: {
    UploadProfilePicture,
    KTPersonalInformation,
    KTChangePassword,
  },

  data() {
    return {
      StartupLoadingFlag: false,
      MemberId: 0,
      rows: {},

      default_photo: "media/users/blank.png",
      current_photo: null,

      UserFlag: false,
      addRecordPrompt: false,
      addRecordPrompt1: false,
      addRecordPrompt2: false,
    };
  },
  computed: {},
  watch: {
    // rows: function () {
    //   console.log("watch rows");
    //   this.current_photo = this.rows.MemberImagePath;
    //   this.default_photo = this.rows.DefaultPhoto;
    // },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.getTableRecords();
    },
    onFileChange(e) {
      const file = e.target.files[0];

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.current_photo = event.target.result;
        };

        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    addRecord() {
      console.log("addRecord called");
      this.addRecordPrompt2 = true;
    },
    changeProfilePhoto(photo) {
      console.log("changeProfilePhoto called");
      this.addRecordPrompt2 = false;
      console.log("photo=" + JSON.stringify(photo));
      if (photo != "") {
        this.rows.MemberImagePath = photo;
      }
    },
    openUpdateProfile() {
      console.log("openUpdateProfile called");
      this.$router.push({ path: "/quick-profile-update" });
    },
    getTableRecords() {
      console.log("getTableRecords called");
      this.StartupLoadingFlag = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/members/show";
      var upload = {
        UserInterface: 1,
        MemberId: this.MemberId,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      // this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));
          thisIns.StartupLoadingFlag = false;

          // thisIns.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records[0];
          console.log({ records });

          if (flag == 1) {
            thisIns.rows = records;
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          // this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          // this.toast("error", output);
          this.StartupLoadingFlag = false;
        });
    },
    generateQrCodeDetails() {
      console.log("generateQrCodeDetails called");
      this.StartupLoadingFlag = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/member-qr-code";
      var upload = {
        UserInterface: 1,
        MemberId: this.MemberId,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var successTxt = "";
      var errorTxt = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));
          thisIns.StartupLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          output = response.data.output;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);
          successTxt = response.data.success;
          errorTxt = response.data.error;
          console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

          if (flag == 1) {
            thisIns.getTableRecords();
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          // this.toast("error", output);
          this.StartupLoadingFlag = false;
        });
    },
    openRecordPrompt() {
      console.log("openRecordPrompt called");
      this.addRecordPrompt = true;
    },
    hideAddRecordPrompt(flag) {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      console.log(flag);
      if (flag) {
        this.getTableRecords();
      }
    },
    openRecordPrompt1() {
      console.log("openRecordPrompt1 called");
      this.addRecordPrompt1 = true;
    },
    hideAddRecordPrompt1() {
      console.log("hideAddRecordPrompt1 called");
      this.addRecordPrompt1 = false;
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["currentUserPersonalInfo"]),
    photo() {
      return this.current_photo == null
        ? this.default_photo
        : this.current_photo;
    },
  },
  beforeMount() {
    console.log("beforeMount called");
    console.log(this.$route.query.id);
    // this.MemberId = this.$route.query.id;
    var MemberId = this.$session.get("MemberId");
    MemberId = MemberId == (null || undefined) ? 0 : MemberId;
    console.log("my-profile beforeMount called");

    var token = this.$session.get("token");
    token = token == (null || undefined) ? 0 : token;

    if (token == 0) {
      this.$router.push("/login");
    } else {
      this.UserFlag = true;
      this.MemberId = MemberId;
      this.refreshPageData();
    }
  },
};
</script>
